import { lazy } from 'react';

export default lazy(
  () => import('containers/Programmations/assets/fr/Programmation/index'),
);
